module.exports = __webpack_public_path__ + "static/DY3-8298ab311e0841a83773c110981b56a6.jpg";